import { useState } from 'react';
import {customFeed} from "../../api";
import {PostList} from '../../post/postList';
import '../../post/style/postfeed.css'
import {useTranslation} from "react-i18next";

function Briefing({data, root}){
  const [posts,setPosts] = useState([]);
  const [cursor,setCursor] = useState('');
  const { t } = useTranslation();
  const [init,setInit]  = useState(false);
  const uniqueArray = (arr1,arr2)=>{
    let ids  = arr1.map((item)=>{return item.id});
    return  arr2.filter((item) =>{return !ids.includes(item.id);});
  }

  let contacts = [];
  let entities = [];
  let themes = [];

  if( root === "contact"){
    contacts.push(data.contact.id);
  }else if( root === "entity"){
    entities.push(data.entity.id);
  }else{
    themes.push(data.theme.id);
  }

  if(!init){
    setInit(true);
    getCustomFeed();
    console.log("data",data);
  }

  function getCustomFeed(){
    if(cursor!==false){
      customFeed(cursor,contacts,entities,themes).then(data => {
        const newList = posts.concat(uniqueArray(posts,data.data));
        setCursor(data.cursor);
        setPosts(newList);
      });
    }
  }

  let view;

  if(posts ===  []){
    view = <p>{t('Aucun élément à afficher')}</p>
  }else{
    view = <div className="c-container_data">
      { posts.length>0 && <PostList users={data.users} apiCall={getCustomFeed} bookmarks={data.bookmarks} posts={posts} cursor={cursor}/> }
    </div>
  }
  return (
      <>
        {view}
      </>
  )
}

export default Briefing
